
import { ILoginRepository } from "./ILoginRepository";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GenericRepository } from "../generic/GenericRepository";
import { Login } from "src/app/models/login.model";
import { environment } from "src/app/globals";
import { map, catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { GetLogin } from "src/app/models/get-login.model";


@Injectable({providedIn :'root'})
export class LoginRepository extends GenericRepository<Login> implements ILoginRepository {
  
    loginModel=new Login();


  constructor(protected _http: HttpClient) {
    super(_http, environment.gbaseURL, environment.gserverName);
  }

  Authentication(login: Login) {
    var data = "username=" + login.Username + "&password=" + login.Password + "&grant_type=password";
    var reqHeader = new HttpHeaders({ 'No-Auth':'True'});
    return this._http.post(environment.gserverName + '/token', data, { headers: reqHeader }).pipe(map(this.extractData),catchError(this.handleError));
  }
  
 
}
